import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WebAPIService } from 'src/app/shared/core/services/web-api.service';
import { AdminUserCreatePayload, AdminUserDetail, AdminUserListItem, PagedResult, UpdateUserRolePayload } from './user.model';

@Injectable()
export class UserService {
    private webAPI = inject(WebAPIService);

    getUsers(filters?: any): Observable<PagedResult<AdminUserListItem>> {
        return this.webAPI.getData('admin/users', filters);
    }

    createUser(payload: AdminUserCreatePayload): Observable<{ userID: number }> {
        return this.webAPI.postData('admin/users', payload);
    }

    getUser(id: number): Observable<AdminUserDetail> {
        return this.webAPI.getData(`admin/users/${id}`);
    }

    resendRegistrationEmail(id: number): Observable<any> {
        return this.webAPI.postData(`admin/users/${id}/resend-registration`, null);
    }

    resetUserMFA(id: number): Observable<any> {
        return this.webAPI.postData(`admin/users/${id}/reset-mfa`, null);
    }

    disableUser(id: number): Observable<any> {
        return this.webAPI.postData(`admin/users/${id}/disable`, null);
    }

    enableUser(id: number): Observable<any> {
        return this.webAPI.postData(`admin/users/${id}/enable`, null);
    }

    updateRole(id: number, payload: UpdateUserRolePayload): Observable<{ role: string; tradingPartnerIDs: number[]; changed: boolean }> {
        return this.webAPI.putData(`admin/users/${id}/role`, payload);
    }
}
